import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {deleteIssueMutation} from './__generated__/deleteIssueMutation.graphql'
import {decrementIssuesTabCounter} from '@github-ui/issues-tab-counter'

export function commitDeleteIssueMutation({
  environment,
  input,
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {issueId: string}
  onCompleted?: () => void
  onError?: (error: Error) => void
}) {
  return commitMutation<deleteIssueMutation>(environment, {
    mutation: graphql`
      mutation deleteIssueMutation($input: DeleteIssueInput!) @raw_response_type {
        deleteIssue(input: $input) {
          issue {
            id
          }
        }
      }
    `,
    variables: {
      input,
    },
    onCompleted: () => {
      onCompleted?.()
      decrementIssuesTabCounter()
    },
    onError: error => onError?.(error),
  })
}
